module.exports = __webpack_public_path__ + "img/align-right.98c9f3d8.svg";